import { all } from 'redux-saga/effects';
import appSaga from "./slices/app/appSaga";
import authSaga from "./slices/auth/authSaga";
import reservationSaga from "./slices/reservation/reservationSaga";

export default function* rootSaga() {
    yield all([appSaga(), authSaga(), reservationSaga()]);
}
